module.exports = __webpack_public_path__ + "static/media/pobal.6a7ee4ad.png";